export default __webpack_public_path__ + "static/media/Bcard1.53ae3d8e.jpg";